import { createAction } from '@reduxjs/toolkit'

import type { PaginatedResponse } from 'api/Cerebro/types'
import type { Brand, DspAdvertiser, Integration, Organization } from 'types'

export const fetchOrganizationSuccess = createAction<Organization>(
    'FETCH_ORGANIZATION_SUCCESS'
)

// fetch brand options
export const fetchBrandOptionsSuccess = createAction<PaginatedResponse<Brand>>(
    'FETCH_ORGANIZATION_BRAND_OPTIONS_SUCCESS'
)

// fetch integration options
export const fetchIntegrationOptionsSuccess = createAction<
    PaginatedResponse<Integration>
>('FETCH_ORGANIZATION_INTEGRATION_OPTIONS_SUCCESS')

// fetch dsp advertisers options
export const fetchDspAdvertiserOptionsSuccess = createAction<
    PaginatedResponse<DspAdvertiser>
>('FETCH_ORGANIZATION_DSP_ADVERTISERS_OPTIONS_SUCCESS')
